/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type FormFieldType = "CHECKBOX" | "DATE" | "MULTILINE_TEXT" | "MULTISELECT" | "NUMBER" | "SELECT" | "SELECT_CUSTOMER" | "SELECT_MACHINE" | "SELECT_ORDER" | "SELECT_USER" | "TEXT";
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormFieldForm_formField$ref: FragmentReference;
declare export opaque type FormFieldForm_formField$fragmentType: FormFieldForm_formField$ref;
export type FormFieldForm_formField = {|
  +id: string,
  +name: string,
  +description: ?string,
  +placeholder: ?string,
  +type: FormFieldType,
  +displayOrder: number,
  +isCreatable: boolean,
  +properties: ?any,
  +options: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +value: string,
  |}>,
  +$refType: FormFieldForm_formField$ref,
|};
export type FormFieldForm_formField$data = FormFieldForm_formField;
export type FormFieldForm_formField$key = {
  +$data?: FormFieldForm_formField$data,
  +$fragmentRefs: FormFieldForm_formField$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "FormFieldForm_formField",
  "type": "FormField",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCreatable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "properties",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "options",
      "storageKey": null,
      "args": null,
      "concreteType": "FormFieldOption",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'acd77cd1d7eda1ce6c6548803466fbf5';
module.exports = node;
